import * as client_hooks from '../../../src/hooks.client.js';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23')
];

export const server_loads = [];

export const dictionary = {
		"/": [9],
		"/auth/callback": [23,[8]],
		"/(authenticated)/search": [10,[2,3]],
		"/(authenticated)/search/activity": [11,[2,3]],
		"/(authenticated)/search/debtor-groups": [12,[2,3]],
		"/(authenticated)/search/debtor-groups/create-debtor-group": [13,[4]],
		"/(authenticated)/search/debtor-groups/edit-debtor-group": [14,[5]],
		"/(authenticated)/search/permissions": [15,[2,3]],
		"/(authenticated)/search/roles": [16,[2,3]],
		"/(authenticated)/search/roles/create-role": [17,[6]],
		"/(authenticated)/search/roles/edit": [18,[7]],
		"/(authenticated)/search/users": [19,[2,3]],
		"/(authenticated)/users": [20,[2]],
		"/(authenticated)/users/create": [22,[2]],
		"/(authenticated)/users/[userId]": [21,[2]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';